import { useState } from 'react';
import { Dialog, TextInputField, Checkbox, toaster } from 'evergreen-ui';
import sectionServices from '../services/sectionServices';

const AddSectionDialog = ({ isShown, onSectionAdded, onClose }) => {
    const [sectionName, setSectionName] = useState('');
    const [isVisibleToEducators, setIsVisibleToEducators] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!sectionName.trim()) {
            toaster.warning('Il nome della sezione non può essere vuoto.');
            return;
        }

        try {
            setIsSubmitting(true);
            const newSection = await sectionServices.addSection({ name: sectionName, is_visible_to_educators: isVisibleToEducators });
            toaster.success('Sezione aggiunta con successo!');
            onSectionAdded(newSection);
            onClose();
        } catch (error) {
            console.error('Errore durante l\'aggiunta della sezione:', error);
            toaster.danger('Errore durante l\'aggiunta della sezione.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetState = () => {
        setSectionName('');
        setIsVisibleToEducators(false);
    };

    return (
        <Dialog
            isShown={isShown}
            title="Aggiungi nuova cartella"
            onCloseComplete={() => {
                resetState();
                onClose();
            }}
            confirmLabel="Aggiungi"
            cancelLabel='Annulla'
            onConfirm={handleSubmit}
            isConfirmLoading={isSubmitting}
        >
            <TextInputField
                label="Nome della nuova cartella"
                placeholder="Inserisci il nome della nuova cartella..."
                value={sectionName}
                onChange={(e) => setSectionName(e.target.value)}
            />
            <Checkbox
                label="Visibile agli educatori"
                checked={isVisibleToEducators}
                onChange={(e) => setIsVisibleToEducators(e.target.checked)}
            />
        </Dialog>
    );
};

export default AddSectionDialog;